import { supabase } from '../../supabaseClient';
import { ENTRY_TYPE, INSTALLMENT_STATUS, STATUS } from '../constants/financial';
import { formatLocalISO } from './financialPeriod';
import { fetchAllRows } from './supabaseFetchAll';

const isoDate = (d) => formatLocalISO(d);
const addDays = (d, n) => {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
};

// Saldo atual (Ajuste 06): usa currentBalance quando os bancos vêm de
// loadBanksWithCurrentBalance; cai para balance (saldo inicial) se ausente.
const bankBalance = (bank) =>
  Number(bank?.currentBalance != null ? bank.currentBalance : bank?.balance) || 0;

export const getInitialBalance = (banks, bankId) => {
  if (bankId) {
    const bank = banks.find((b) => String(b.id) === String(bankId));
    return bankBalance(bank);
  }
  return banks
    .filter((b) => b.status === STATUS.ATIVO)
    .reduce((sum, b) => sum + bankBalance(b), 0);
};

export const computeDailyProjection = (movements, initialBalance, horizonDays, today = new Date()) => {
  const baseDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const days = [];
  for (let i = 0; i <= horizonDays; i++) {
    const d = addDays(baseDate, i);
    days.push({ date: isoDate(d), entradas: 0, saidas: 0, saldoAcumulado: 0 });
  }
  const byDate = new Map(days.map((d) => [d.date, d]));

  movements.forEach((m) => {
    const day = byDate.get(m.due_date);
    if (!day) return;
    const value = Number(m.value) || 0;
    if (m.financial_entry?.type === ENTRY_TYPE.RECEITA) day.entradas += value;
    else if (m.financial_entry?.type === ENTRY_TYPE.DESPESA) day.saidas += value;
  });

  let acc = Number(initialBalance) || 0;
  days.forEach((d) => {
    acc += d.entradas - d.saidas;
    d.saldoAcumulado = acc;
  });
  return days;
};

export const loadProjectedMovements = async ({ companyId, bankId, horizonDays }) => {
  const today = new Date();
  const fromDate = isoDate(today);
  const toDate = isoDate(addDays(today, horizonDays));

  const buildQuery = () => {
    let query = supabase
      .from('Installment')
      .select(
        'id, due_date, value, payment_method, ' +
          'Bank(id, name), ' +
          'financial_entry:FinancialEntry!inner(id, type, supplier_client, description, company_id, deleted_at)'
      )
      .eq('financial_entry.company_id', companyId)
      .is('deleted_at', null)
      .is('financial_entry.deleted_at', null)
      .eq('status', INSTALLMENT_STATUS.PENDENTE)
      .gte('due_date', fromDate)
      .lte('due_date', toDate);

    if (bankId) query = query.eq('bank_id', bankId);

    return query
      .order('due_date', { ascending: true })
      .order('id', { ascending: true });
  };

  const { data, error } = await fetchAllRows(buildQuery);
  if (error || !data) return [];
  return data;
};
